// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.NumberedList = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.NumberedList = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var NumberedList = _exports.NumberedList = function NumberedList(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 18 18",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.625 5.0625H15.75M5.625 9H15.75M5.625 12.9375H15.75",
      stroke: "currentColor",
      "stroke-width": "0.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M0 11.7H3.6V11.4104C2.84835 11.3804 2.7956 11.3705 2.63736 11.2706C2.45275 11.1508 2.4 10.951 2.4 10.282V7.31609C2.4 6.13773 2.43956 5.2889 2.50549 4.5C1.85934 4.61983 1.0022 4.70971 0 4.75964V5.04924H0.501099C0.830769 5.04924 0.989011 5.06921 1.09451 5.13911C1.2 5.20902 1.2 5.20902 1.22637 6.07781V10.282C1.22637 11.001 1.16044 11.2107 0.87033 11.3105C0.698901 11.3705 0.567033 11.3804 0 11.4104V11.7Z",
      fill: "currentColor"
    }));
  };
});
